import React from 'react';
import { VippedPage } from '../../components/Views/VippedPage';
import { getSeoData } from '../../utils/helpers';
import { Layout } from '../../components/Layout/Layout';
import { getFilterVariantsForVipPage } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { parseVippedFiltersFromQuery } from '../../utils/helpers/vipped';
import { getBreadcrumbs } from '../../utils/helpers/getBreadcrumbs';
import CONFIG from '../../config';

const Vipped = props => <VippedPage {...props} />;

Vipped.getInitialProps = async ({ apolloClient, asPath, req, query, lng }) => {
  const adaptFilter = parseVippedFiltersFromQuery(query);
  const isBaseVipPage = !Object.keys(adaptFilter).length;
  const currentLang = lng || CONFIG.defaultLocale;

  try {
    const [filterVariantsForVipPage, seoData] = await Promise.all([
      apolloClient.query({ query: getFilterVariantsForVipPage }),
      getSeoData(apolloClient, asPath, req),
      getStaticData(apolloClient)
    ]);

    const { breadcrumbs, currAdaptFilter } = getBreadcrumbs(
      filterVariantsForVipPage?.data,
      adaptFilter,
      'vipped'
    );

    return {
      seoData,
      breadcrumbs,
      isBaseVipPage,
      adaptFilter: currAdaptFilter,
      currentLang
    };
  } catch (error) {
    console.error('Error fetching data:', error);

    return {
      isBaseVipPage,
      adaptFilter,
      breadcrumbs: [],
      seoData: {},
      currentLang,
      ssrError: true
    };
  }
};

Vipped.getLayout = page => (
  <Layout isBottomNavigation hideMobileHeader>
    {page}
  </Layout>
);

export default Vipped;
